export const SUPPORTED_LANGUAGES = ["en", "he", "es", "it", "fr", "de", "pt", "ar", "el", "ru", "tr", "zh"];
export const DEFAULT_LANGUAGE = "en";